"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = ['small', 'medium'];

var AnomalyIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AnomalyIcon, _React$PureComponent);

  function AnomalyIcon() {
    _classCallCheck(this, AnomalyIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnomalyIcon).apply(this, arguments));
  }

  _createClass(AnomalyIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svgs = {
        small: {
          viewBox: '0 0 9 9',
          path: _react.default.createElement("path", {
            fill: color,
            d: "M5.37809234,1.56119972 L8.66910703,7.4534268 C8.93841729,7.93559942 8.76585825,8.54479665 8.28368563,8.8141069 C8.13464316,8.89735233 7.96677084,8.94105615 7.79605628,8.94105615 L1.20597678,8.94105615 C0.65369203,8.94105615 0.20597678,8.4933409 0.20597678,7.94105615 C0.20597678,7.76998897 0.249861235,7.60178186 0.333434002,7.45251843 L3.63249881,1.56029135 C3.90231074,1.07839928 4.51168724,0.906474357 4.99357931,1.17628629 C5.15486095,1.26658807 5.28795847,1.39982418 5.37809234,1.56119972 Z"
          })
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("path", {
            fill: color,
            d: "M6.87789557,1.60947522 L11.1933534,9.52114787 C11.4578161,10.0059962 11.2791583,10.6134328 10.7943099,10.8778956 C10.6474213,10.9580166 10.4827768,11 10.3154578,11 L1.68454219,11 C1.13225744,11 0.68454219,10.5522847 0.68454219,10 C0.68454219,9.83268101 0.726525562,9.66803647 0.806646617,9.52114787 L5.12210443,1.60947522 C5.38656716,1.12462688 5.99400379,0.945969046 6.47885213,1.21043177 C6.64741865,1.30237715 6.7859502,1.4409087 6.87789557,1.60947522 Z"
          })
        }
      };
      /* eslint-enable max-len */

      var svg = svgs[size];
      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'anomaly-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return AnomalyIcon;
}(_react.default.PureComponent);

exports.default = AnomalyIcon;
AnomalyIcon.defaultProps = {
  color: 'inherit',
  size: 'medium'
};
AnomalyIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string,

  /**
   * Size of icon.
   */
  size: _propTypes.default.oneOf(sizes)
};